import script from "./TablePostGraph.vue?vue&type=script&lang=ts&setup=true"
export * from "./TablePostGraph.vue?vue&type=script&lang=ts&setup=true"

import "./TablePostGraph.vue?vue&type=style&index=0&id=748f9458&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2780876773/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-748f9458"]])

export default __exports__